import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Popover, Space, Typography } from 'antd';
const { Title, Text } = Typography;

export interface SpidInfoPopoverProps {}

/**
 * Popover informativo Agig-Spid
 */
export function SpidInfoPopover(props: SpidInfoPopoverProps) {
  const { t } = useTranslation();

  return (
    <Popover
      placement="bottomRight"
      content={
        <div style={{ width: '90%', maxWidth: '400px' }}>
          <Space direction="vertical">
            <Title level={4}>
              {t('user.login.spid-popover.title', 'Accesso con utenza SPID')}
            </Title>
            <Text>
              {t(
                'user.login.spid-popover.text-part-a',
                'SPID è il sistema di accesso che consente di utilizzare, con un’identità digitale unica, i servizi online della Pubblica Amministrazione, sia centrale, sia locale, e dei privati accreditati.',
              )}{' '}
              {t(
                'user.login.spid-popover.text-part-b',
                'Se sei già in possesso di un’identità digitale, accedi con le credenziali del tuo gestore. Se non hai ancora un’identità digitale, richiedila utilizzando il link a seguire:',
              )}
            </Text>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <a
                href={t(
                  'user.login.spid-link.info-url',
                  'https://www.spid.gov.it',
                )}
                target="_blank"
                rel="noreferrer"
              >
                {t('user.login.spid-link.info', 'Maggiori informazioni')}
              </a>
              <a
                href={t(
                  'user.login.spid-link.dont-have-spid-url',
                  'https://www.spid.gov.it/richiedi-spid',
                )}
                target="_blank"
                rel="noreferrer"
              >
                {t('user.login.spid-link.dont-have-spid', 'Non hai SPID?')}
              </a>
              <a
                href={t(
                  'user.login.spid-link.need-help-url',
                  'https://www.spid.gov.it/serve-aiuto',
                )}
                target="_blank"
                rel="noreferrer"
              >
                {t('user.login.spid-link.need-help', 'Serve aiuto?')}
              </a>
              <div style={{ textAlign: 'center', marginTop: '12px' }}>
                <img
                  src={require('../../../assets/img/spid-agid-logo-lb.svg')}
                  alt="spid-Agid"
                  style={{ width: '90%', maxWidth: '280px', margin: '0 auto' }}
                />
              </div>
            </Space>
          </Space>
        </div>
      }
      trigger="click"
    >
      <QuestionCircleOutlined style={{ height: '1.3em' }} />
    </Popover>
  );
}
